/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { MinusIcon } from "./MinusIcon/MinusIcon";
import { PlusIcon } from "./PlusIcon/PlusIcon";
import {
  buttonStyle,
  disabledRootStyle,
  errorRootStyle,
  inputStyle,
  rootStyle,
} from "./amountStyles";
import { useAmount } from "./useAmount";

import type { AmountProps } from "./amountProps";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const Amount: FcWithoutChildren<AmountProps> = (props) => {
  const { amount, isDisabled, isError, onAmountDecrement, onAmountIncrement } =
    props;
  const { handleAmountChange } = useAmount(props);
  const rootStyles = [
    rootStyle,
    isDisabled && disabledRootStyle,
    isError && errorRootStyle,
  ];

  return (
    <div css={rootStyles}>
      <button
        css={buttonStyle}
        disabled={isDisabled}
        onClick={onAmountDecrement}
      >
        <MinusIcon height={13} width={13} />
      </button>
      <input
        css={inputStyle}
        disabled={isDisabled}
        name="amount"
        type="text"
        value={amount}
        onChange={handleAmountChange}
      />
      <button
        css={buttonStyle}
        disabled={isDisabled}
        onClick={onAmountIncrement}
      >
        <PlusIcon height={13} width={13} />
      </button>
    </div>
  );
};
